import moment from 'moment-timezone'

// Regra de vencimento: o que vence hoje ainda não está vencido, e vencimentos
// de sábado/domingo passam a valer na segunda (só ficam vencidos na terça).
export function effectiveDueDate(due) {
  const date = typeof due === 'string' ? moment(due.substring(0, 10), 'YYYY-MM-DD') : moment(due).startOf('day')
  if (date.day() === 6) date.add(2, 'day')
  else if (date.day() === 0) date.add(1, 'day')
  return date
}

export function isOverdue(due) {
  if (!due) return false
  const today = moment.tz('America/Sao_Paulo').format('YYYY-MM-DD')
  return effectiveDueDate(due).format('YYYY-MM-DD') < today
}
